import { Dispatch, SetStateAction } from "react";
import {
  IStandard,
  IStandardAggregations,
} from "@/search/Langston/types/IStandard";
import { IStandardsFetchParam } from "@/search/Langston/types/IFetchStandards";

export interface IStandardsSearchContext {
  top5Standards: IStandard[] | never[] | undefined;
  selectedStandards: IStandard[];
  updateSelectedStandardsOnChange: (
    isChecked: boolean,
    standard: IStandard,
    updateSelectedStandards?: boolean,
  ) => void;
  allStandardsModalResults: IStandard[];
  standardsInQuery: string[];
  totalStandardsResults: number;
  fetchFilteredStandards: (params?: IStandardsFetchParam) => void;
  isLoadingStandardsResults: boolean;
  handleViewMoreStandards: () => void;
  currentNeedle: string;
  setCurrentNeedle: (needle: string) => void;
  currentPage: number;
  handleStandardsSearch: (
    needle: string,
    subject?: string,
    year?: string,
  ) => void;
  resetStandardsSearch: () => void;
  showViewMoreButton: boolean;
  setSelectedStandards: Dispatch<SetStateAction<IStandard[]>>;
  getTemporarySelectedFilters: () => IStandard[];
  clearTemporarySelectedFilters: () => void;
  standardAggregations: IStandardAggregations | null;
}

export const standardsSearchProviderInitialValue: IStandardsSearchContext = {
  top5Standards: [],
  selectedStandards: [],
  updateSelectedStandardsOnChange: () => null,
  allStandardsModalResults: [],
  standardsInQuery: [],
  totalStandardsResults: 0,
  fetchFilteredStandards: () => null,
  isLoadingStandardsResults: false,
  handleViewMoreStandards: () => null,
  currentNeedle: "",
  setCurrentNeedle: () => null,
  currentPage: 1,
  handleStandardsSearch: () => null,
  resetStandardsSearch: () => null,
  showViewMoreButton: false,
  setSelectedStandards: () => null,
  getTemporarySelectedFilters: () => [],
  clearTemporarySelectedFilters: () => null,
  standardAggregations: null,
};

export const TOTAL_RESULTS_LIMIT_PER_PAGE = 30;
